var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"accom-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"score-span"},[_vm._v(_vm._s(_vm.score))])])])}
var staticRenderFns = []

export { render, staticRenderFns }